import React, { useEffect, useState } from 'react';
import './SettingsScreen.css';
import { SettingsType } from '../interfaces/SettingsType';
import EditEntryCode from '../components/EditEntryCode';
import EditPilots from '../components/EditPilots';
import { getBackendVersion } from '../firebase/db-stats';
import BackupArea from '../components/BackupArea';

interface SettingsScreenProps {
  settings: SettingsType | undefined;
  updateSettings: (settings: SettingsType) => void;
}

const SettingsScreen: React.FC<SettingsScreenProps> = ({
  settings,
  updateSettings,
}) => {
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [editedSettings, setEditedSettings] = useState(settings);
  const [backendVersion, setBackendVersion] = useState();

  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    const version = await getBackendVersion();
    setBackendVersion(version);
  }

  const handleEditClick = (index: number) => {
    setEditingIndex(index);
  };

  const handleSaveClickProfile = () => {
    if (editedSettings && settings !== undefined) {
      updateSettings(editedSettings);
      setEditingIndex(null);
      setEditedSettings(undefined);
    }
  };

  const handleCancelClick = () => {
    setEditingIndex(null);
    setEditedSettings(undefined);
  };

  // System-Informationen
  const reactVersion = React.version;
  const appVersion = process.env.REACT_APP_VERSION || '1.0.0';
  const nodeVersion = process.env.REACT_APP_NODE_VERSION || 'N/A';
  const browserInfo = navigator.userAgent;
  const platformInfo = navigator.platform;

  return (
    <div className="settings-container">
      <div className="settings-title">
        <h1>Einstellungen</h1>
      </div>

      <h3>Profil</h3>

      <div className="email-item">
        {editingIndex === -2 ? (
          <div className="edit-container">
            {settings?.isAdmin ? (
              <>
                <label>Einrichtung</label>
                <input
                  type="text"
                  value={settings?.prename}
                  onChange={(e) => {
                    if (settings)
                      setEditedSettings({
                        ...settings,
                        prename: e.currentTarget.value,
                      });
                  }}
                  className="edit-input"
                />
              </>
            ) : (
              <>
                <label>Vorname</label>
                <input
                  type="text"
                  value={editedSettings?.prename}
                  onChange={(e) => {
                    setEditedSettings({
                      ...editedSettings,
                      prename: e.currentTarget.value,
                    } as SettingsType);
                  }}
                  className="edit-input"
                />
                <label>Nachname</label>
                <input
                  type="text"
                  value={editedSettings?.lastname}
                  onChange={(e) => {
                    setEditedSettings({
                      ...editedSettings,
                      lastname: e.currentTarget.value,
                    } as SettingsType);
                  }}
                  className="edit-input"
                />
              </>
            )}
            <button
              onClick={handleSaveClickProfile}
              className="save-button-settings"
            >
              Save
            </button>
            <button onClick={handleCancelClick} className="cancel-button">
              Cancel
            </button>
          </div>
        ) : (
          <>
            <span className="email-text">
              {settings?.prename + ' ' + settings?.lastname}
            </span>
            <button onClick={() => handleEditClick(-2)} className="edit-button">
              <span className="material-icons-settings">edit_square</span>
            </button>
          </>
        )}
      </div>
      {settings && settings.isAdmin === true ? (
        <EditPilots settings={settings} updateSettings={updateSettings} />
      ) : (
        <EditEntryCode settings={settings} updateSettings={updateSettings} />
      )}

      {settings && settings.isAdmin === true && <BackupArea />}
      <div className="system-info-section">
        <h3>System Information</h3>
        <ul>
          <li>
            <strong>React Version:</strong> {reactVersion}
          </li>
          <li>
            <strong>Node Version:</strong> {backendVersion}
          </li>
          <li>
            <strong>App Version:</strong> {appVersion}
          </li>
          <li>
            <strong>Browser:</strong> {browserInfo}
          </li>
          <li>
            <strong>Platform:</strong> {platformInfo}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SettingsScreen;
